import { createContext, useContext } from 'react';
import { InitStates, Modes, MsgTypes } from "@context/DefaultValues";
import type { IContext } from "msgdsk-types";
import { log } from '@libs/utilsMsg';

export const contextReducer:any = ( draft:any, action:any ) =>  {
	if (!action) log("CONTEXT_REDUCER missing action", [draft, action]);

	switch (action.type) {
		case "MAIN_MENU": {
			if (action.hasOwnProperty('form') && action.hasOwnProperty('state')) {
				
			} else if (action.hasOwnProperty('form')) {
				draft.main_menu.form = action.form;
			} else if (action.hasOwnProperty('state')) {
				const state = action.state;
				const current_state = draft.main_menu.state
				const msg_type = draft?.msg?.msg_type;
				const isShow = state !== current_state;

				draft.main_menu.state = isShow ? state : "";
				draft.state = isShow ? "msg_menu" : "init";

				if (["site"].includes(msg_type)) {
					draft.main_menu.form = isShow ? "compact_std" : "compact";
				}
			}				
			
			return void draft.main_menu;
		}
		case "STATE": {
			action.state = action.state ?? "init";	
			
			if (action.state === "init") {
				draft.mode = Modes.is_empty;
				draft.find_enabled = false;
				draft.namekey_error = false;
				draft.namekey = "";
				draft.is_info_str = {};
				draft.is_focused = "SearchInput";
				draft.is_found = false;
				draft.is_pin_form = false;
				draft.is_google_it = false;
				draft.is_textarea = false;
				draft.msgType = MsgTypes[0];				
			} else if (action.state === "disabled") {
				action.namekey = action?.namekey ?? "";
				const is_empty = action.namekey === "";
				draft.mode = is_empty ? Modes.is_empty : {};
				draft.namekey = action.namekey;
				draft.is_info_str = {};
				draft.is_focused = "SearchInput";
				draft.is_found = false;
				draft.is_pin_form = false;
				draft.is_google_it = false;
				draft.is_textarea = false;
				if (is_empty) draft.msgType = MsgTypes[0];
			} else if (action.state === "finding") {
				draft.mode = Modes.is_ok;
				// draft.namekey = "";
				draft.is_info_str = {};
				draft.is_focused = "SearchInput";
				draft.is_found = false;
				draft.is_pin_form = false;
				draft.is_google_it = false;
				draft.is_textarea = false;
			} else if (action.state === "enabled") {
				const namekey = action?.namekey ?? "";
				const is_empty = namekey === "";	
				const is_error = action?.is_error ?? false;	
				draft.mode = Modes.is_ok;
				draft.namekey_error = is_error;
				draft.find_enabled = !is_empty && !is_error;
				draft.namekey = namekey;
				draft.is_info_str = {};
				draft.is_focused = "SearchInput";
				draft.is_found = false;
				draft.is_pin_form = false;
				draft.is_google_it = false;
				draft.is_textarea = false;		
				draft.msgType = MsgTypes[0]; // if (draft.state === "create") 								
			} else if (action.state === "create") {
				action.is_found = action?.is_found ?? false;	
				action.is_google_it = action?.is_google_it ?? false;
				
				draft.mode = Modes.is_create;
				draft.find_enabled = true;
				// draft.namekey = action.namekey;
				draft.is_info_str = { val: "not_found" };
				draft.is_focused = "TextInput";
				draft.is_found = action.is_found;
				draft.is_pin_form = false;
				draft.is_google_it = action.is_google_it;
				draft.is_textarea = true;	
				draft.is_conf_form = false;				
			} else if (action.state === "google") {
				const found = action?.found ?? "";
				const is_found = found !== "";
				
				draft.mode = !is_found ? Modes.is_ok : Modes.is_create;
				draft.find_enabled = !is_found;
				draft.is_info_str = { val: (is_found ? "found" : "not_found"), href: found };
				draft.is_focused = "TextInput";
				draft.is_found = is_found;
				draft.is_pin_form = false;
				draft.is_google_it = true;
				draft.is_textarea = !is_found;	
				draft.is_conf_form = false;				
			} else if (action.state === "captcha") {
				const is_unpinned = !draft.is_pin_form || draft.pin !== "";
				
				if (is_unpinned) {
					draft.mode = Modes.is_captcha;	
					draft.is_info_str = { val: "not_found" };
					draft.is_focused = "TextInput";
					draft.is_found = action.is_found;
					draft.is_pin_form = false;
					draft.is_google_it = false;
					draft.is_textarea = true;	
					draft.is_conf_form = false;							
				}					
			} else if (action.state === "conf") {
				const is_conf = !draft.is_conf_form;
								
				draft.is_conf_form = is_conf;	
				draft.mode = Modes.is_create;	
				if (!is_conf) draft.is_info_str_create = "";
			} else if (action.state === "protect") {
				const is_pin = !draft.is_pin_form;
				draft.find_enabled = true;
				draft.is_pin_form = is_pin;
				draft.mode = Modes.is_create;	
				if (!is_pin) draft.is_info_str_create = "";	
			}
			
			draft.state = action.state;
			
			return void draft.state;
		}
		case "SET": {
			if (action?.mode) {		
				draft.mode = action.mode
				return void draft.mode;
			} else if (action.hasOwnProperty('find_enabled')) {
				draft.find_enabled = action.find_enabled
				return void draft.find_enabled;
			} else if (action.hasOwnProperty('namekey_error')) {
				draft.namekey_error = action.namekey_error;
				return void draft.namekey_error;
			} else if (action.hasOwnProperty('captcha')) {
				draft.captcha = action.captcha
				return void draft.captcha;
			} else if (action.hasOwnProperty('state')) {
				draft.state = action.state
				return void draft.state;
			} else if (action.hasOwnProperty('msg')) {
				draft.msg = action.msg
				return void draft.msg;
			} else if (action.hasOwnProperty('pin')) {
				draft.pin = action.pin
				return void draft.pin;
			} else if (action.hasOwnProperty('is_focused')) {
				draft.is_focused = action.is_focused
				return void draft.is_focused;
			} else if (action.hasOwnProperty('namekey')) {
				draft.namekey = action.namekey
				return void draft.namekey;
			} else if (action.hasOwnProperty('prefix')) {
				draft.prefix = action.prefix
				return void draft.prefix;
			} else if (action.hasOwnProperty('is_info_str')) {
				draft.is_info_str = action.is_info_str
				return void draft.is_info_str;
			} else if (action.hasOwnProperty('is_conf_form')) {
				draft.is_conf_form = action.is_conf_form
				return void draft.is_conf_form;
			} else if (action.hasOwnProperty('msgType')) {
				draft.msgType = action.msgType
				return void draft.msgType;
			} else if (action.hasOwnProperty('is_info_str_create')) {
				draft.is_info_str_create = action.is_info_str_create
				return void draft.is_info_str_create;
			} else if (action.hasOwnProperty('is_pin_form')) {
				draft.is_pin_form = action.is_pin_form
				return void draft.is_pin_form;
			} else if (action.hasOwnProperty('is_textarea')) {
				draft.is_textarea = action.is_textarea
				return void draft.is_textarea;
			} else if (action.hasOwnProperty('is_google_it')) {
				draft.is_google_it = action.is_google_it
				return void draft.is_google_it;
			} else if (action.hasOwnProperty('is_found')) {
				draft.is_found = action.is_found
				return void draft.is_found;
			} else if (action.hasOwnProperty('app')) {
				draft.app = action.app
				return void draft.app;
			}
			break			
		}
	}
}

export interface IAppContext {
  dispatchContext: typeof contextReducer, 
  context_data: IContext
}

export const AppContext = (() => {
	log("createContext:", InitStates);
	return createContext<IAppContext>(null!);
})();

export const useAppContext = () => {
	const currentContext = useContext(AppContext);

	if (!currentContext) {
		throw new Error(
			"useAppContext has to be used within <useAppContext.Provider>"
		);
	}

	return currentContext;
}
